module.exports = __webpack_public_path__ + "img/user18.afc10460.jpg";